import { useContext } from 'react';

import { ContextualCommentTargetContext } from './context';

export const useContextualCommentTarget = () => useContext(ContextualCommentTargetContext);
